import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import update from "immutability-helper";
import { I18n } from "@aws-amplify/core";
import {
  get,
  filter,
  map,
  includes,
  toLower,
  size,
  forEach,
  indexOf,
} from "lodash";

import { fetchPost } from "../../../api/fetch";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CustomButton from "../../Common/CustomButton";
import CloseIcon from "../../Common/CloseIcon";
import Loader from "../../Common/Loader";
import DriveInOutForm from "./DriveInOutForm";

import {
  fetchLogsTabNew,
  getLatestLog,
} from "../../../actions/siteEntranceExit/tabs";

import { dbFormat } from "../../../utils/date";

import { driveInOut } from "../../../constants/reducers";
import { STATIC_TAB } from "../../../constants/siteEntranceExit";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    maxWidth: "calc(100vw - 100px)",
    minWidth: "768px",
    maxHeight: "calc(100vh - 60px)",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: "12px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1.142em",
    color: colors.black87,
    textAlign: "center",
    textTransform: "uppercase",
  },
  postCreationBtn: {
    margin: "10px 0px",
  },
  titleBarItem: {
    display: "flex",
    alignItems: "center",
  },
  actionButton: {
    margin: "10px",
  },
};

const AddDriveInOutDialog = (props) => {
  const { classes, dispatch, open, eventGroupType } = props;
  const [isSubmiting, setIsSubmiting] = React.useState(false);

  const initialFormValues = {
    dateType: "current",
    date: Date.now(),
    profiles: [],
  };
  const [formValues, setFormValues] = React.useState(initialFormValues);

  const zoneTab = get(props, ["match", "params", "zoneId"]);

  React.useEffect(() => {
    if (zoneTab && open) {
      handleChange("zone", null, parseInt(zoneTab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneTab, open]);

  const closeDialog = () => {
    setFormValues(initialFormValues);
    setIsSubmiting(false);
    props.closeDialog();
  };

  const setDefaultValues = (defaultValues) => {
    setFormValues({
      ...formValues,
      ...defaultValues,
    });
  };

  const handleChange = (id, index, value) => {
    if (id === "addProfile") {
      if (size(get(formValues, ["profiles"])) < 8) {
        setFormValues(
          update(formValues, {
            profiles: { $push: [value] },
          })
        );
      }
    } else if (id === "removeProfile") {
      let index;
      forEach(get(formValues, ["profiles"]), (p, i) => {
        if (p.id === value.id) {
          index = i;
        }
      });
      setFormValues(
        update(formValues, {
          profiles: { $splice: [[index, 1]] },
        })
      );
    } else if (id === "date") {
      setFormValues(
        update(formValues, {
          [id]: { $set: new Date(value).getTime() },
        })
      );
    } else if (id === "dateType" && value === "current") {
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
          date: { $set: Date.now() },
        })
      );
    } else if (includes(toLower(id), "profile")) {
      setFormValues(
        update(formValues, {
          profiles: {
            [id]: { $set: value },
          },
        })
      );
    } else {
      setFormValues(
        update(formValues, {
          [id]: { $set: value },
        })
      );
    }

    // Set auto focus
    // let element = document.getElementById("autoFocusProfile");
    // element.focus();
  };

  const isValidForm = () => {
    let valid = true;
    if (!get(formValues, ["zone"])) valid = false;
    if (!get(formValues, ["date"])) valid = false;
    if (
      size(
        filter(
          get(formValues, ["profiles"]),
          (p) => get(p, ["type", "id"]) === 1
        )
      ) === 0 ||
      size(
        filter(
          get(formValues, ["profiles"]),
          (p) => get(p, ["type", "id"]) === 2
        )
      ) === 0
    ) {
      valid = false;
    }
    return valid;
  };

  const submit = async (decision) => {
    try {
      setIsSubmiting(true);

      let date =
        get(formValues, ["dateType"]) === "current"
          ? Date.now()
          : get(formValues, ["date"]);

      let body = {
        type_id: get(eventGroupType, ["id"]),
        description: get(formValues, ["note"]),
        active: true,
        site_id: get(formValues, ["site"]),
        zone_id: get(formValues, ["zone"]),
        events: [],
      };

      for (let i = 0; i < size(get(formValues, ["profiles"])); i++) {
        let profile = get(formValues, ["profiles", i]);
        let index = indexOf(
          map(
            filter(
              get(formValues, ["profiles"]),
              (p) => get(profile, ["type", "id"]) === get(p, ["type", "id"])
            ),
            (p) => p.id
          ),
          profile.id
        );

        let event = {
          profile_type_id: get(profile, ["type", "id"]),
          profile_id: get(profile, ["id"]),
          attributes: [
            {
              id: get(eventGroupType, ["id"]) === 2 ? 76 : 77,
              value: dbFormat(date, "YYYY-MM-DD[T]HH:mm:ss.SS[Z]"),
            },
            {
              id: 105,
              value: decision,
            },
          ],
        };

        // Carrier attribute
        if (get(formValues, ["carrier"])) {
          event.attributes.push({
            id: 89,
            value: get(formValues, ["carrier"]),
          });
        }

        // Trailer/Container sequence number
        if (includes([3, 4], get(profile, ["type", "id"]))) {
          event.attributes.push({
            id: 121,
            value: index + 1,
          });
        }

        // Driver/Passenger attribute
        if (includes([1], get(profile, ["type", "id"]))) {
          event.attributes.push({
            id: 102,
            value: index > 0 ? false : true,
          });
        }

        body.events.push(event);
      }

      await fetchPost("driveinout/event_groups", body);

      if (!zoneTab) {
        dispatch(fetchLogsTabNew(driveInOut, 0, null));
      } else {
        let tabs = get(props, ["siteEntranceExit", driveInOut, "tabs"]);
        let index;
        forEach(tabs, (t, i) => {
          if (
            get(t, ["type"]) === STATIC_TAB &&
            get(t, ["zone", "id"]) === parseInt(zoneTab)
          ) {
            index = i;
          }
        });
        dispatch(getLatestLog(driveInOut, index));
      }

      closeDialog();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Dialog
      open={open}
      classes={{
        root: classes.dialogRoot,
        paperScrollPaper: classes.dialog,
      }}
    >
      {isSubmiting ? (
        <Box
          style={{
            width: "400px",
            height: "200px",
            display: "flex",
            margin: "auto",
          }}
        >
          <Loader noDecoration message={I18n.get("site_creating")} />
        </Box>
      ) : (
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {`${
                  get(eventGroupType, ["id"]) === 2
                    ? I18n.get("sidebar_driveIn")
                    : I18n.get("sidebar_driveOut")
                } (${I18n.get("common_new")})`}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={closeDialog} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <DriveInOutForm
              eventGroupTypeId={get(eventGroupType, ["id"])}
              formValues={formValues}
              handleChange={handleChange}
              setDefaultValues={setDefaultValues}
            />
          </Grid>
          <Grid
            item
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CustomButton
              className={classes.actionButton}
              variant="contained"
              startIcon={
                <img
                  src={isValidForm() ? images.deniedWhite : images.deniedGrey}
                  alt="deny"
                />
              }
              disabled={!isValidForm()}
              style={{
                backgroundColor: isValidForm() ? colors.errorRed : null,
                color: isValidForm() ? colors.white : null,
                minWidth: "100px",
              }}
              onClick={() => submit(44)}
            >
              {I18n.get("site_deny")}
            </CustomButton>
            <CustomButton
              className={classes.actionButton}
              variant="contained"
              startIcon={
                <img
                  src={
                    isValidForm()
                      ? images.requireAssistanceWhite
                      : images.requireAssistanceGrey
                  }
                  alt="require_assistance"
                />
              }
              disabled={!isValidForm()}
              style={{
                backgroundColor: isValidForm() ? colors.selectedOrange : null,
                color: isValidForm() ? colors.white : null,
                minWidth: "100px",
              }}
              onClick={() => submit(93)}
            >
              {I18n.get("dashboard_requireAssistance")}
            </CustomButton>
            <CustomButton
              className={classes.actionButton}
              variant="contained"
              startIcon={
                <img
                  src={isValidForm() ? images.allowedWhite : images.allowedGrey}
                  alt="allowed"
                />
              }
              disabled={!isValidForm()}
              style={{
                backgroundColor: isValidForm() ? colors.cardGreen : null,
                color: isValidForm() ? colors.white : null,
                minWidth: "100px",
              }}
              onClick={() => submit(43)}
            >
              {I18n.get("site_allow")}
            </CustomButton>
          </Grid>
          <Grid
            item
            className="text-center"
            style={{ margin: "10px 0px 20px" }}
          >
            <CustomButton color="primary" onClick={closeDialog}>
              {I18n.get("site_cancel")}
            </CustomButton>
          </Grid>
        </Grid>
      )}
    </Dialog>
  );
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: get(state, ["siteEntranceExit"]),
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(AddDriveInOutDialog))
);
